import { mapState, mapGetters, mapActions } from 'vuex'

export const targetDoorSettingComputed = {
  ...mapState('targetDoorSetting', {}),

  ...mapGetters('targetDoorSetting', [
    'getListDeviceDetail',
    'createDetailDevice',
    'createDetailDeviceSuccess',
    'getTotalPage',
    'getIsLoading',
  ]),
}

export const targetDoorSettingMethods = mapActions('targetDoorSetting', [
  'getDeviceDetail',
  'createDeviceTarget',
])
